import { render, staticRenderFns } from "./IconMiddleBottom.vue?vue&type=template&id=bbb696c2&"
import script from "./IconMiddleBottom.vue?vue&type=script&lang=js&"
export * from "./IconMiddleBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbb696c2')) {
      api.createRecord('bbb696c2', component.options)
    } else {
      api.reload('bbb696c2', component.options)
    }
    module.hot.accept("./IconMiddleBottom.vue?vue&type=template&id=bbb696c2&", function () {
      api.rerender('bbb696c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/PopupButtonPositions/IconMiddleBottom.vue"
export default component.exports